var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('strong',[_vm._v(_vm._s(_vm.totalResults)+" result"+_vm._s(_vm.totalResults > 1 ? 's' : ''))]),_vm._v(" found"),(_vm.searchTerm)?[_vm._v(" for \""+_vm._s(_vm.searchTerm)+"\"")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }